import { render, staticRenderFns } from "./UserConnectedAccountsItem.vue?vue&type=template&id=063d6ceb&"
import script from "./UserConnectedAccountsItem.vue?vue&type=script&lang=js&"
export * from "./UserConnectedAccountsItem.vue?vue&type=script&lang=js&"
import style0 from "./UserConnectedAccountsItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports